export default "__VITE_ASSET__CDmv59fY__"